import { combineReducers } from '@reduxjs/toolkit';

import { api } from './api/api';
import { authApi } from './api/auth.api';
import chatSlice from './reducers/chat.slice';
import commonSlice from './reducers/common.slice';
import ordersSlice from './reducers/orders.slice';
import registrationSlice from './reducers/registration.slice';

export const rootReducers = combineReducers({
  [api.reducerPath]: api.reducer,
  [authApi.reducerPath]: authApi.reducer,
  common: commonSlice,
  registration: registrationSlice,
  orders: ordersSlice,
  chat: chatSlice,
});
